import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SellerPage } from '@/features/land/seller-page';

const searchSchema = z.object({
  tab: z.enum(['listings', 'enquiries']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/land/sell/$orgId/')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  const { tab = 'listings' } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SellerPage
      orgId={orgId}
      tab={tab}
      onTab={(next) => void navigate({ search: { tab: next }, replace: true })}
    />
  );
}
